// src/utils/ensureJpeg.ts
import heic2any from 'heic2any';

export async function ensureJpeg(file: File, quality = 0.85): Promise<File> {
  if (file.type === 'image/jpeg') return file;

  // Try native decode first
  try {
    const bmp = await createImageBitmap(file);
    const canvas = document.createElement('canvas');
    canvas.width = bmp.width;
    canvas.height = bmp.height;
    const ctx = canvas.getContext('2d')!;
    // flatten transparency to black (change if you prefer white)
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bmp, 0, 0);

    const blob: Blob = await new Promise((res) =>
      canvas.toBlob((b) => res(b!), 'image/jpeg', quality)
    );
    return new File([blob], replaceExt(file.name, '.jpg'), { type: 'image/jpeg' });
  } catch { /* fall through */ }

  // Fallback for HEIC/HEIF when browser can’t decode
  if (/\.(heic|heif)$/i.test(file.name) || /heic/i.test(file.type)) {
    const blob = (await heic2any({ blob: file, toType: 'image/jpeg', quality })) as Blob;
    return new File([blob], replaceExt(file.name, '.jpg'), { type: 'image/jpeg' });
  }

  // Unknown exotic image → keep original rather than break UX
  return file;
}

function replaceExt(name: string, ext: string) {
  return name.replace(/\.[^.]+$/, '') + ext;
}
